import {Pipe, PipeTransform} from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the PadUpcPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'padUpc',
})
export class PadUpcPipe implements PipeTransform {
  constructor(private vizixService: VizixService) {
  }

  transform(value: string, pad: number = parseFloat(this.vizixService.configurationApp.AppParametersConfiguration.UPCLength.value)) {
    while (value.length < pad) {
      value = "0" + value;
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/pad-upc.ts